import { Flex } from 'foundations-components/components/Flex';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledIcon = styled.svg.withConfig({
  displayName: "BaseSvg__StyledIcon",
  componentId: "od8a5w-0"
})(({
  $size
}) => {
  return {
    blockSize: $size,
    inlineSize: $size
  };
});
export const BaseSvg = ({
  children,
  name,
  size
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    position: "absolute",
    inset: "0",
    alignItems: "center",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(StyledIcon, {
      $size: size,
      viewBox: "0 0 216 216",
      focusable: "false",
      xmlns: "http://www.w3.org/2000/svg",
      "data-svg-name": name,
      children: children
    })
  });
};